// src/pages/NewsPage.js
import React from "react"
import { List, Typography, Card } from "antd"
import { ReadOutlined } from "@ant-design/icons"

const { Title, Paragraph } = Typography

const fakeNews = [
  {
    title: "Chính sách bảo hiểm mới áp dụng từ 01/07/2025",
    content:
      "Bộ Tài chính đã công bố những thay đổi trong việc đăng ký và gia hạn bảo hiểm xe...",
  },
  {
    title: "5 điều cần biết khi mua bảo hiểm ô tô lần đầu",
    content:
      "Nếu bạn là người mua bảo hiểm ô tô lần đầu, hãy lưu ý những điều sau đây...",
  },
  {
    title: "Cảnh báo lừa đảo giả mạo công ty bảo hiểm",
    content:
      "Cục Cạnh tranh và Bảo vệ người tiêu dùng đã đưa ra cảnh báo về tình trạng giả mạo...",
  },
]

const NewsPage = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #f8f9fa, #e9ecef)",
        padding: "24px 16px",
      }}
    >
      <div
        style={{
          maxWidth: 800,
          margin: "0 auto",
          background: "rgba(255, 255, 255, 0.95)",
          borderRadius: "20px",
          padding: "28px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
        }}
      >
        <Title
          level={3}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "24px",
            color: "#1a1a1a",
          }}
        >
          <ReadOutlined style={{ color: "#764ba2" }} /> Tin tức bảo hiểm
        </Title>

        <List
          itemLayout="vertical"
          dataSource={fakeNews}
          renderItem={(item, index) => (
            <List.Item key={index} style={{ padding: "12px 0" }}>
              <Title level={5} style={{ marginBottom: 8 }}>
                {item.title}
              </Title>
              <Paragraph style={{ color: "#555", fontSize: "15px" }}>
                {item.content}
              </Paragraph>
            </List.Item>
          )}
        />
      </div>
    </div>
  )
}

export default NewsPage
